import { createAsyncActionType } from './index';

export const SEARCH_WORD_SET = '@@search/SEARCH_WORD_SET';

export const SEARCH_COURSES_LIST_GET = createAsyncActionType(
  'search',
  'SEARCH_COURSES_LIST_GET'
);

export const SEARCH_MODULES_LIST_GET = createAsyncActionType(
  'search',
  'SEARCH_MODULES_LIST_GET'
);

export const SEARCH_EVENTS_LIST_GET = createAsyncActionType(
  'search',
  'SEARCH_EVENTS_LIST_GET'
);

export const SEARCH_DOCUMENTS_LIST_GET = createAsyncActionType(
  'search',
  'SEARCH_DOCUMENTS_LIST_GET'
);

export const SEARCH_DOCUMENTS_EXPERT_LIST_GET = createAsyncActionType(
  'search',
  'SEARCH_DOCUMENTS_EXPERT_LIST_GET'
);
